import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import ViewerPage from './pages/ViewerPage';
import { initScrollRestoration, scrollToTopInstant } from './utils/scrollRestoration';

initScrollRestoration();

/**
 * Route Scroll Manager: ensures that whenever an artwork viewer route is loaded,
 * scroll is strictly placed at the very top (0, 0) so the "Back to Exhibition"
 * link is immediately visible.
 */
const RouteScrollManager: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/gallery')) {
      scrollToTopInstant();
    }
  }, [location.pathname]);

  return null;
};

/**
 * Handles legacy paths like /gallery-template.html?id=artwork-id
 * and redirects cleanly to /gallery/:id
 */
const LegacyGalleryRedirect: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get('id');
  if (id) {
    return <Navigate to={`/gallery/${encodeURIComponent(id)}`} replace />;
  }
  return <Navigate to="/" replace />;
};

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <RouteScrollManager />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery/:id" element={<ViewerPage />} />
          <Route path="/gallery-template.html" element={<LegacyGalleryRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
